import { fetchNewsBySlug, fetchPaginatedNews, searchNews } from '../../api/news/index';

export const fetchNewsBySlugApi = async (payload: any) => {
  const response = await fetchNewsBySlug(payload);
  return response;
};
export const fetchPaginatedNewsApi = async (payload: any) => {
  const response = await fetchPaginatedNews(payload);
  return response;
};
export const searchNewsApi = async (payload: any) => {
  const response = await searchNews(payload);
  return response;
}
